import { defaultFileUploadConfig as foundationConfig, FileUpload as FoundationFileUpload, foundationFileUploadShadowOptions, } from '@genesislcap/foundation-ui';
import { zeroFileUploadStyles } from './file-upload.styles';
import { fileUploadTemplate as template } from './file-upload.template';
export const defaultFileUploadConfig = foundationConfig;
export const zeroFileUploadShadowOptions = foundationFileUploadShadowOptions;
/**
 * @tagname %%prefix%%-file-upload
 */
export class FileUpload extends FoundationFileUpload {
}
/**
 * The Zero FileUpload
 *
 * @public
 * @remarks
 * HTML Element: \<zero-file-upload\>
 */
export const zeroFileUpload = FileUpload.compose(Object.assign({ baseName: 'file-upload', shadowOptions: zeroFileUploadShadowOptions, styles: zeroFileUploadStyles, template }, defaultFileUploadConfig));
